import { useQuery } from "@tanstack/react-query";
import { estimateApi } from "./estimate.api";
import { GetEstimatesParams } from "~/types/estimate";

export const ESTIMATE_KEYS = {
  ESTIMATES: "estimates",
  ESTIMATE: (id: string) => {
    const key = ["estimate", id];
    console.log("🔑 ESTIMATE_KEYS.ESTIMATE called with:", id, "→ key:", key);
    return key;
  },
  GET_ESTIMATES: (params: GetEstimatesParams) => ["estimates", params],
  EXPO_SUMMARY: (serviceId: string) => ["expo-summary", serviceId],
  IS_EXPO_MODE: (estimateId: string) => ["is-expo-mode", estimateId],
};

export const useGetEstimates = (params: GetEstimatesParams) => {
  return useQuery({
    queryKey: ESTIMATE_KEYS.GET_ESTIMATES(params),
    queryFn: () => estimateApi.getAll(params),
  });
};

export const useGetEstimate = (id: string) => {
  const query = useQuery({
    queryKey: ESTIMATE_KEYS.ESTIMATE(id),
    queryFn: () => estimateApi.getById(id),
    enabled: !!id,
  });

  console.log("🔍 useGetEstimate:");
  console.log("  - ID:", id);
  console.log("  - Query key:", ESTIMATE_KEYS.ESTIMATE(id));
  console.log("  - Data:", query.data);
  console.log("  - Services count:", query.data?.services?.length);

  return query;
};

// Expo Mode Queries
export const useGetExpoServiceSummary = (serviceId: string, enabled = true) => {
  return useQuery({
    queryKey: ESTIMATE_KEYS.EXPO_SUMMARY(serviceId),
    queryFn: () => estimateApi.getExpoServiceSummary(serviceId),
    enabled: !!serviceId && enabled,
  });
};

export const useIsExpoMode = (estimateId: string, enabled = true) => {
  return useQuery({
    queryKey: ESTIMATE_KEYS.IS_EXPO_MODE(estimateId),
    queryFn: () => estimateApi.isExpoMode(estimateId),
    enabled: !!estimateId && enabled,
  });
};
